const DryCakeData = [
  {
    productname: "Choco Brownie",
    productdescription:
      "Fudgy brownies made from plant-based cream and chocolate",
  },
  {
    productname: "Choco Walnut Cake",
    productdescription:
      "Soft and delicious cake slices with the goodness of soya milk, organic sugar, whole wheat and millet. With the best all-natural ingredients, each bite gives a mouth-watering flavour",
  },
  {
    productname: "Dry Fruit Cake",
    productdescription: "Dry cake loaded with dry fruits and nuts",
  },
  {
    productname: "Dates Almond Cake",
    productdescription:
      "Raw dates & almond dry cake sweetened by jaggery and date syrup",
  },
];
export default DryCakeData;
